import i18next from "i18next";

export default ({ distance = "" }) => {
  return (
    <div className="distance">{`${distance?.toLocaleString()} ${i18next.t(
      "KM"
    )}`}</div>
  );
};
